import { useMemo } from 'react';
import { STORY_POINTS, ORIGINAL_ESTIMATE } from '../../../../../../model/constants';
import type { EstimationType } from '../../../../../../model/types';
import type { Assignee } from '../../../types';

type SortKey = 'storyPoints' | 'originalTimeEstimateInSeconds' | 'issueCount';

export function useSortAssignees(assignees: Assignee[], estimationType: EstimationType) {
	const sortKey = getSortKey(estimationType);
	return useMemo(
		() => [...assignees].sort((a, b) => b[sortKey] - a[sortKey]),
		[assignees, sortKey],
	);
}

export function getSortKey(estimationType: EstimationType): SortKey {
	switch (estimationType) {
		case STORY_POINTS:
			return 'storyPoints';
		case ORIGINAL_ESTIMATE:
			return 'originalTimeEstimateInSeconds';
		default:
			return 'issueCount';
	}
}
